// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://darkviolet-mandrill-145960.hostingersite.com/",
});

export default axiosInstance;

// export const weburl = "https://listmein.onrender.com/";
export const weburl = "https://darkviolet-mandrill-145960.hostingersite.com/";

export const shopurl = "https://adminontech.spacedeco.in/";
export const mainurl = "https://ontech.spacedeco.in/";
export const fronturl = "https://adminontech.spacedeco.in/";
export const MAPKEY = "AIzaSyDYsdaR0zrPsBDeuyCKFH_4PuCUyWcQ2mE";

export const socketURL = "https://listmein.onrender.com/";

export const keyLogin = process.env.REACT_APP_LOGIN_KEY;